import { ChevronLeft } from "lucide-react";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.scss";

export interface PageHeaderProps {
  title: ReactNode;
  backText?: string;
  backTo?: string;
  onBack?: () => void;
  extra?: ReactNode;
}

export function PageHeader({
  title,
  backText = "Back",
  backTo,
  onBack,
  extra,
}: PageHeaderProps) {
  const hasBack = Boolean(backTo || onBack);

  return (
    <div className={styles.breadcrumb}>
      <div className={styles.breadcrumbLeft}>
        {hasBack && (
          <>
            {backTo ? (
              <Link to={backTo} className={styles.breadcrumbLink}>
                <ChevronLeft size={16} className={styles.breadcrumbIcon} />
                <span className={styles.breadcrumbText}>{backText}</span>
              </Link>
            ) : (
              <span
                className={styles.breadcrumbLink}
                onClick={onBack}
                style={{ cursor: "pointer" }}
              >
                <ChevronLeft size={16} className={styles.breadcrumbIcon} />
                <span className={styles.breadcrumbText}>{backText}</span>
              </span>
            )}
            <span className={styles.breadcrumbSeparator}>/</span>
          </>
        )}
        <h1 className={styles.breadcrumbTitle}>{title}</h1>
      </div>
      {extra && <div>{extra}</div>}
    </div>
  );
}
